module.exports = __webpack_public_path__ + "static/media/minusButton.19851732.svg";